import { render, staticRenderFns } from "./SupplierRawMaterialCommercialDetails.vue?vue&type=template&id=90d9e048&scoped=true&"
import script from "./SupplierRawMaterialCommercialDetails.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialCommercialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d9e048",
  null
  
)

export default component.exports